import http from '../../../Services/api.laravel.http';

export const ProductUnitService = {
    getSingleProductUnit: (id) => http.get('/admin/setting/product-unit/' + id),
    ArchiveProductUnit: (formParams) =>
        http.post('/admin/setting/product-unit/archives/list', formParams),
    paginateWithSearchProductUnit: (formParams) =>
        http.post('/admin/setting/product-unit/search', formParams),
    productUnitPost: (formParams) =>
        http.post('/admin/setting/product-unit', formParams),
    updateProductUnit: (formParams, id) =>
        http.put('/admin/setting/product-unit/' + id, formParams),
};
